// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-marker-container {
  --first-heading: 0;
  display: none;
  align-items: center;
  justify-content: center;
  transition: width 0.2s, height 0.2s;
}
.user-marker-container .unlock-radius {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background: rgba(83, 140, 247, 0.3019607843);
}
.user-marker-container .unlock-radius:before {
  content: "";
  position: absolute;
  display: block;
  box-sizing: border-box;
  border-radius: 100%;
  width: 110%;
  height: 110%;
  background: rgb(255, 255, 255);
  animation: 10s radius-glow 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}
.user-marker-container .unlock-radius.init .direction-cone-container, .user-marker-container .unlock-radius.init .marker-core {
  animation: 5s init-animation cubic-bezier(0.67, 0.02, 0.18, 1);
}
.user-marker-container .unlock-radius .marker-core {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #538cf7;
  width: 10%;
  height: 10%;
  min-width: 26px;
  min-height: 26px;
  font-size: 16px;
  border: 2px solid var(--motes-white);
  border-radius: 100%;
  transform-origin: center;
}
.user-marker-container .unlock-radius .marker-core svg-icon .svg-icon {
  display: flex;
}
.user-marker-container .unlock-radius .direction-cone-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  transform-origin: center;
}
.user-marker-container .unlock-radius .direction-cone-container .direction-cone {
  width: 75%;
  height: 47%;
  border-radius: 100%;
  background: conic-gradient(from -45deg at bottom, rgba(0, 0, 0, 0), rgba(255, 255, 255, 0.59) 1deg 90deg, rgba(0, 0, 0, 0) 91deg);
  -webkit-mask: linear-gradient(transparent 14%, #000);
}
@keyframes radius-glow {
  0% {
    opacity: 1;
    transform: scale(0.33);
  }
  10%, 100% {
    opacity: 0;
    transform: scale(1);
  }
}
@keyframes init-animation {
  0% {
    transform: rotate(calc(var(--first-heading) * 1deg));
  }
  50% {
    transform: rotate(calc((var(--first-heading) + 360) * 1deg));
  }
  100% {
    transform: rotate(calc((var(--first-heading) + 720) * 1deg));
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/user-map-marker/user-map-marker.component.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;AADJ;AAGI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AADR;AAGQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,0EAAA;AADZ;AAKY;EACI,8DAAA;AAHhB;AAOQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,wBAAA;AALZ;AAOY;EACI,aAAA;AALhB;AASQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,wBAAA;AAPZ;AASY;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,iIAAA;EACA,oDAAA;AAPhB;AAYI;EACI;IACI,UAAA;IACA,sBAAA;EAVV;EAYM;IACI,UAAA;IACA,mBAAA;EAVV;AACF;AAaI;EACI;IACI,oDAAA;EAXV;EAaM;IACI,4DAAA;EAXV;EAaM;IACI,4DAAA;EAXV;AACF","sourcesContent":[".user-marker-container {\n    // This will be overridden with first valid heading\n    --first-heading: 0;\n\n    display: none;\n    align-items: center;\n    justify-content: center;\n    transition: width 0.2s, height 0.2s;\n\n    .unlock-radius {\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        border-radius: 100%;\n        background: #538cf74d;\n\n        &:before {\n            content: \"\";\n            position: absolute;\n            display: block;\n            box-sizing: border-box;\n            border-radius: 100%;\n            width: 110%;\n            height: 110%;\n            background: rgb(255 255 255);\n            animation: 10s radius-glow 2s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;\n        }\n\n        &.init {\n            .direction-cone-container, .marker-core {\n                animation: 5s init-animation cubic-bezier(0.67, 0.02, 0.18, 1);\n            }\n        }\n\n        .marker-core {\n            position: absolute;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: #538cf7;\n            width: 10%;\n            height: 10%;\n            min-width: 26px;\n            min-height: 26px;\n            font-size: 16px;\n            border: 2px solid var(--motes-white);\n            border-radius: 100%;\n            transform-origin: center;\n\n            svg-icon .svg-icon {\n                display: flex;\n            }\n        }\n\n        .direction-cone-container {\n            width: 100%;\n            height: 100%;\n            display: flex;\n            justify-content: center;\n            transform-origin: center;\n\n            .direction-cone {\n                width: 75%;\n                height: 47%;\n                border-radius: 100%;\n                background: conic-gradient(from -45deg at bottom, rgba(0, 0, 0, 0), rgb(255 255 255 / 59%) 1deg 90deg, rgba(0, 0, 0, 0) 91deg);\n                -webkit-mask: linear-gradient(transparent 14% ,#000);\n            }\n        }\n    }\n\n    @keyframes radius-glow {\n        0% {\n            opacity: 1;\n            transform: scale(.33);\n        }\n        10%, 100% {\n            opacity: 0;\n            transform: scale(1);\n        }\n    }\n\n    @keyframes init-animation {\n        0% {\n            transform: rotate(calc(var(--first-heading) * 1deg));\n        }\n        50% {\n            transform: rotate(calc((var(--first-heading) + 360) * 1deg));\n        }\n        100% {\n            transform: rotate(calc((var(--first-heading) + 720) * 1deg));\n        }\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
